import { default as _4035R7MMdWhzcMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/403.vue?macro=true";
import { default as ai_45product_45data_45generationbR1kjqFTEvMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/assistant/ai-product-data-generation.vue?macro=true";
import { default as ai_45product_45data_45purgeHblEuqfLXaMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/assistant/ai-product-data-purge.vue?macro=true";
import { default as _91id_932LtDtxBFHYMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/assistant/ai-product-data-review/[id].vue?macro=true";
import { default as indexgwvlCoJl0rMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/assistant/ai-product-data-review/index.vue?macro=true";
import { default as ai_45product_45data_45reviewdmnQBGey07Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/assistant/ai-product-data-review.vue?macro=true";
import { default as _91id_93fWsUJBIFflMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/assistant/ai-product-data/[id].vue?macro=true";
import { default as index8ThjmLOcWNMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/assistant/ai-product-data/index.vue?macro=true";
import { default as assistantAttributesSelect_46inputlvx2vZcErzMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/assistant/inputs/assistantAttributesSelect.input.ts?macro=true";
import { default as _91id_93D9X8ngipm2Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/attribute-groups/[id].vue?macro=true";
import { default as indexd43E69A1ElMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/attribute-groups/index.vue?macro=true";
import { default as newwGyD5XG6q2Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/attribute-groups/new.vue?macro=true";
import { default as attribute_45groupscBjtbq1ibnMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/attribute-groups.vue?macro=true";
import { default as _91lang_932vjEtfpXJcMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/attributes/[id]/attribute-values/[lang].vue?macro=true";
import { default as indexxdS1uj3C9tMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/attributes/[id]/index.vue?macro=true";
import { default as indexlfcXadvw3BMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/attributes/index.vue?macro=true";
import { default as _91id_930fnCTyOLJvMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/authors/[id].vue?macro=true";
import { default as indexLlXn2QAOZWMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/authors/index.vue?macro=true";
import { default as newAl4cmW0fPhMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/authors/new.vue?macro=true";
import { default as index4ydUxFzD29Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/baselinker/index.vue?macro=true";
import { default as basketsim2E6ao78acaMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/basketsim.vue?macro=true";
import { default as adspend_45toggleJgJbnEFIfLMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/bi-center/filters/adspend-toggle.ts?macro=true";
import { default as fast_45delivery_45toggleJ9n2aVQxT6Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/bi-center/filters/fast-delivery-toggle.ts?macro=true";
import { default as metric_45datepUcLoDbUz1Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/bi-center/filters/metric-date.ts?macro=true";
import { default as indexLWEjsnmEEXMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/bi-center/index.vue?macro=true";
import { default as manufacturer_45marginsPBDp8bctbKMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/bi-center/manufacturer-margins.vue?macro=true";
import { default as manufacturersTFuet1910wMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/bi-center/manufacturers.vue?macro=true";
import { default as margin_45checksUG0qtlcDs6Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/bi-center/margin-checks.vue?macro=true";
import { default as metrics_45values3R3cALaHAmMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/bi-center/metrics-values.vue?macro=true";
import { default as performance_45stocks5NQy0gMilGMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/bi-center/performance-stocks.vue?macro=true";
import { default as poasLFKwfnHM3LMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/bi-center/poas.vue?macro=true";
import { default as product_45metricsfUs2QjJyBwMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/bi-center/product-metrics.vue?macro=true";
import { default as _91productId_93_45_91channelId_93ZqdyfpLkPqMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/bi-center/product-poas/[productId]-[channelId].vue?macro=true";
import { default as index5rdJx333aSMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/bi-center/product-poas/index.vue?macro=true";
import { default as statsOHzLnNT9P9Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/bi-center/stats.vue?macro=true";
import { default as bi_45centerYpuZUFVgeyMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/bi-center.vue?macro=true";
import { default as indexixurtsQVHQMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/cache/index.vue?macro=true";
import { default as _91id_93WNBrPUhd2oMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/campaigns/[id].vue?macro=true";
import { default as index6cz7uHggNVMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/campaigns/index.vue?macro=true";
import { default as new57XBmzFTp8Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/campaigns/new.vue?macro=true";
import { default as _91id_93dErMtRpqVBMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/carriers/[id].vue?macro=true";
import { default as indexwxh0KIfohkMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/carriers/index.vue?macro=true";
import { default as newpgSjuXmBpyMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/carriers/new.vue?macro=true";
import { default as carriersi3nBdw5WWvMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/carriers.vue?macro=true";
import { default as _91id_93kT9fAPJFixMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/categories/[id].vue?macro=true";
import { default as clone_45treez1OxyW4UF1Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/categories/clone-tree.vue?macro=true";
import { default as active_46selectRImEYEg4xmMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/categories/filters/active.select.ts?macro=true";
import { default as emptyDescription_46toggleG50azyGytHMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/categories/filters/emptyDescription.toggle.ts?macro=true";
import { default as emptyHeaderImage_46selectAtKDhgMSQcMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/categories/filters/emptyHeaderImage.select.ts?macro=true";
import { default as emptyName_46selectImyUOvdHkIMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/categories/filters/emptyName.select.ts?macro=true";
import { default as emptyProductFilters_46selectnyz05D5vaHMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/categories/filters/emptyProductFilters.select.ts?macro=true";
import { default as emptySateliteDesc_46selectC6BmMjHEqVMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/categories/filters/emptySateliteDesc.select.ts?macro=true";
import { default as emptySeoDesc_46togglebt5PUuU1XUMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/categories/filters/emptySeoDesc.toggle.ts?macro=true";
import { default as emptySeoTitle_46togglemSOc6FKmIaMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/categories/filters/emptySeoTitle.toggle.ts?macro=true";
import { default as excludeFromAutoComplete_46selectb6tKuvIiNcMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/categories/filters/excludeFromAutoComplete.select.ts?macro=true";
import { default as query_46selectXZx7PkPofhMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/categories/filters/query.select.ts?macro=true";
import { default as sort_46select6xofEb18FRMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/categories/filters/sort.select.ts?macro=true";
import { default as status_46selectqr6QXybPGMMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/categories/filters/status.select.ts?macro=true";
import { default as virtual_46select3qIup4k4pXMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/categories/filters/virtual.select.ts?macro=true";
import { default as visibility_46select4fxARcUsKAMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/categories/filters/visibility.select.ts?macro=true";
import { default as indexJ0dCg0skVoMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/categories/index.vue?macro=true";
import { default as categoryAttributes_46inputsG7sBYxpGxMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/categories/inputs/categoryAttributes.input.ts?macro=true";
import { default as categoryTree_46inputJBdbzSK4EvMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/categories/inputs/categoryTree.input.ts?macro=true";
import { default as mappingsDfqc4swkbYMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/categories/mappings.vue?macro=true";
import { default as newcNdTGnlCjtMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/categories/new.vue?macro=true";
import { default as _91id_9333RmHOa7qeMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/categories/product-sorting/[id].vue?macro=true";
import { default as treeXSHAORMv3eMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/categories/tree.vue?macro=true";
import { default as indexPf7lkkugaaMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/categories/virtual-categories/index.vue?macro=true";
import { default as categoriesnS8EbYffbVMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/categories.vue?macro=true";
import { default as _91id_93s823F2OjEaMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/channels/[id].vue?macro=true";
import { default as available_46selectagk9zSJWmoMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/channels/filters/available.select.ts?macro=true";
import { default as hasMapping_46selectQZ2fvGgDStMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/channels/filters/hasMapping.select.ts?macro=true";
import { default as indexYXtlsURpxRMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/channels/index.vue?macro=true";
import { default as fisEnabled_46togglekdkUQZSChtMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/channels/inputs/fisEnabled.toggle.ts?macro=true";
import { default as overwrite_46toggle2SV2MHmOgQMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/channels/inputs/overwrite.toggle.ts?macro=true";
import { default as productsStatus_46inputRXxmfeTKnPMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/channels/inputs/productsStatus.input.ts?macro=true";
import { default as sitemaps_46inputsC4mTtZ0383Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/channels/inputs/sitemaps.inputs.ts?macro=true";
import { default as type_46inputGG2eTMsN7RMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/channels/inputs/type.input.ts?macro=true";
import { default as migrationzyR9Fg9dzdMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/channels/migration.vue?macro=true";
import { default as newl9buSQ6FyYMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/channels/new.vue?macro=true";
import { default as remote_45categoriesDeIPaHh7FFMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/channels/remote-categories.vue?macro=true";
import { default as channelsrfYjpYtyfuMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/channels.vue?macro=true";
import { default as _91id_938Z72QgkkxNMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/collections/[id].vue?macro=true";
import { default as index09gbVvYLqlMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/collections/index.vue?macro=true";
import { default as newxt40iLob8rMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/collections/new.vue?macro=true";
import { default as _91id_93G0lMclzIpKMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/countries/[id].vue?macro=true";
import { default as indexnv3IEzKrJxMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/countries/index.vue?macro=true";
import { default as new4z8EtTHpTGMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/countries/new.vue?macro=true";
import { default as _91id_938CPKvTcXToMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/currencies/[id].vue?macro=true";
import { default as indexQJlfPHtywqMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/currencies/index.vue?macro=true";
import { default as newgXkikXXEDiMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/currencies/new.vue?macro=true";
import { default as currenciesFMRcSs2qiHMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/currencies.vue?macro=true";
import { default as _91id_93POup07KYe7Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/customer-groups/[id].vue?macro=true";
import { default as indexfly2XtWyriMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/customer-groups/index.vue?macro=true";
import { default as newW1tMrmIZaRMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/customer-groups/new.vue?macro=true";
import { default as customer_45groupsyRT5mOunDLMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/customer-groups.vue?macro=true";
import { default as mailmogJGYazsSMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/customers/[customer]/mail.vue?macro=true";
import { default as _91message_93k0vvKS1Wz7Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/customers/[customer]/messages/[message].vue?macro=true";
import { default as _91id_934hyqvfhMgcMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/customers/[id].vue?macro=true";
import { default as index3Z9e21mOW0Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/customers/index.vue?macro=true";
import { default as isMarketingAccepted_46toggleqZpcRcKvT7Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/customers/inputs/isMarketingAccepted.toggle.ts?macro=true";
import { default as isMarketingSubscribed_46toggleOdUoqLQHuxMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/customers/inputs/isMarketingSubscribed.toggle.ts?macro=true";
import { default as isTermsAccepted_46togglebbUbEbrajkMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/customers/inputs/isTermsAccepted.toggle.ts?macro=true";
import { default as new1l2e3S62bjMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/customers/new.vue?macro=true";
import { default as _91id_93AAXbxDoTkyMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/delivery-methods/[id].vue?macro=true";
import { default as indexS4h1daTlmgMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/delivery-methods/index.vue?macro=true";
import { default as newzS98Kr97XtMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/delivery-methods/new.vue?macro=true";
import { default as _91id_93LNQ9t2tKfcMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/delivery-methods/services/[id].vue?macro=true";
import { default as indexraMITQyR9ZMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/delivery-methods/services/index.vue?macro=true";
import { default as newdFxi5H3AADMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/delivery-methods/services/new.vue?macro=true";
import { default as index7Cn7bLV1K7Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/exports/[id]/index.vue?macro=true";
import { default as statsphqRSe0bcXMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/exports/[id]/stats.vue?macro=true";
import { default as indexyPguRoSq9zMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/exports/debug/index.vue?macro=true";
import { default as indexTO6f8cJIXEMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/exports/index.vue?macro=true";
import { default as modeldKfURpnBO0Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/exports/model.ts?macro=true";
import { default as indexoWJzqBzbqoMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/exports/new/[id]/index.vue?macro=true";
import { default as indexbThUsJ6nmnMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/exports/new/index.vue?macro=true";
import { default as exportsbeaElidDiPMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/exports.vue?macro=true";
import { default as _91id_93tTipI97VG7Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/flags/[id].vue?macro=true";
import { default as index6upimesbRRMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/flags/index.vue?macro=true";
import { default as isHidden_46inputfIOXlmZAyrMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/flags/inputs/isHidden.input.ts?macro=true";
import { default as new26PGPqdb9LMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/flags/new.vue?macro=true";
import { default as flagsjEvszKmT2SMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/flags.vue?macro=true";
import { default as indexDqVjABrvq4Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/image-studio/index.vue?macro=true";
import { default as image_45studio4ZFRIyP2e8Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/image-studio.vue?macro=true";
import { default as _91id_93WGwnJooDTsMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/imports/[id].vue?macro=true";
import { default as import_45type_46select5IuBktdgJxMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/imports/filters/import-type.select.ts?macro=true";
import { default as parent_45import_46selectlHz9H9ZOf9Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/imports/filters/parent-import.select.ts?macro=true";
import { default as status_46selectr0JfFUpXS3Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/imports/filters/status.select.ts?macro=true";
import { default as _91id_934rNTbth1PKMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/imports/import-rows/[id].vue?macro=true";
import { default as status_46selectSPlmLbtskIMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/imports/import-rows/filters/status.select.ts?macro=true";
import { default as indexQadwMSXy6XMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/imports/index.vue?macro=true";
import { default as new_45oldEDDgihaB6dMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/imports/new-old.vue?macro=true";
import { default as indexIXv77ktBthMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/imports/new/[id]/index.vue?macro=true";
import { default as indexvBzfs61ag1Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/imports/new/index.vue?macro=true";
import { default as indexC5KqrEWhY6Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/index.vue?macro=true";
import { default as _91id_93q9uqcQMUIYMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/inspiration-images/[id].vue?macro=true";
import { default as indexqPiK6yOfuBMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/inspiration-images/index.vue?macro=true";
import { default as newfJIq2rb5PvMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/inspiration-images/new.vue?macro=true";
import { default as _91id_93ayd1y6EvGPMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/inspirations/[id].vue?macro=true";
import { default as indexxu4zg7NiUiMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/inspirations/index.vue?macro=true";
import { default as newSnk7KN4ne2Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/inspirations/new.vue?macro=true";
import { default as inspirationsMWA8BWjqhRMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/inspirations.vue?macro=true";
import { default as index3XGyowxm2VMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/integrations/hq-stock/index.vue?macro=true";
import { default as indexwnxGJtIzf8Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/integrations/index.vue?macro=true";
import { default as indexfOxJHv6n8pMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/integrations/kare-tracking/index.vue?macro=true";
import { default as indexnYpG1cP1evMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/internal/product-index/index.vue?macro=true";
import { default as status_46selectHfiefdbZS9Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/jobs/filters/status.select.ts?macro=true";
import { default as types_46selectQu2bc6Q9haMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/jobs/filters/types.select.ts?macro=true";
import { default as indexrYSvlfBclvMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/jobs/index.vue?macro=true";
import { default as knowledge_45baseI85zmtfZ8tMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/knowledge-base.vue?macro=true";
import { default as _91id_93EWbD5tSBlpMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/languages/[id].vue?macro=true";
import { default as index7SHCriKMbCMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/languages/index.vue?macro=true";
import { default as news82z8mZqcbMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/languages/new.vue?macro=true";
import { default as _91id_93xVleIhtBQyMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/links/[id].vue?macro=true";
import { default as indexN8lSsqW3zYMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/links/index.vue?macro=true";
import { default as newL7U9dLJGlBMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/links/new.vue?macro=true";
import { default as _91id_93BWgFtk46ggMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/listing-dividers/[id].vue?macro=true";
import { default as indexE3JPai07ajMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/listing-dividers/index.vue?macro=true";
import { default as new0sL9S13Mt5Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/listing-dividers/new.vue?macro=true";
import { default as loginkrvcOSgXW8Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/login.vue?macro=true";
import { default as logoutHlq2CDdZkWMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/logout.vue?macro=true";
import { default as _91id_93MR0fHu4HKLMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/mailchimp-list-configs/[id].vue?macro=true";
import { default as indexGVCKANRYmYMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/mailchimp-list-configs/index.vue?macro=true";
import { default as new4K0Tlx0yybMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/mailchimp-list-configs/new.vue?macro=true";
import { default as _91id_93ZvJJs2KOtrMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/manufacturer-deliveries/[id].vue?macro=true";
import { default as index1V57eejR2PMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/manufacturer-deliveries/bulk-create/index.vue?macro=true";
import { default as dayOfWeekSelect_46inputbNy2pgvGfEMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/manufacturer-deliveries/bulk-create/inputs/dayOfWeekSelect.input.ts?macro=true";
import { default as periodSelect_46inputfQ3YLbKTlsMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/manufacturer-deliveries/bulk-create/inputs/periodSelect.input.ts?macro=true";
import { default as indexqFgn1A2xSgMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/manufacturer-deliveries/bulk-delete/index.vue?macro=true";
import { default as indext2aZuVHu2XMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/manufacturer-deliveries/index.vue?macro=true";
import { default as newoYfN1P1IZJMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/manufacturer-deliveries/new.vue?macro=true";
import { default as manufacturer_45deliveriesF2cyX3mvoQMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/manufacturer-deliveries.vue?macro=true";
import { default as _91id_93PR9ScRA46PMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/manufacturers/[id].vue?macro=true";
import { default as index8i9Cf35PsUMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/manufacturers/index.vue?macro=true";
import { default as new6WBrz20OlQMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/manufacturers/new.vue?macro=true";
import { default as manufacturersxSXk8U4sugMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/manufacturers.vue?macro=true";
import { default as indexhzDT6SAXAjMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/meble/index.vue?macro=true";
import { default as _91id_93CZKGIpcEhsMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/menu/[id].vue?macro=true";
import { default as indexYGr2PwJ9tmMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/menu/index.vue?macro=true";
import { default as layout_46inputOUzOkjmLdrMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/menu/inputs/layout.input.ts?macro=true";
import { default as type_46inputFr2UxcCVdIMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/menu/inputs/type.input.ts?macro=true";
import { default as newmkNJDuDPgSMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/menu/new.vue?macro=true";
import { default as utilsVXSkdqSEafMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/menu/utils.ts?macro=true";
import { default as indexaQxASEldghMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/module-groups/[id]/index.vue?macro=true";
import { default as __91type_9308OoCCvTDPMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/module-groups/[id]/modules/_[type].vue?macro=true";
import { default as _91moduleId_93wp8H4N9pooMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/module-groups/[id]/modules/[moduleId].vue?macro=true";
import { default as _91type_93EkBEiXkYKcMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/module-groups/[id]/modules/edit/[moduleId]/[type].vue?macro=true";
import { default as _91type_93iKSbyqrbL6Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/module-groups/[id]/modules/new/[type].vue?macro=true";
import { default as indexkM7DyWiZAKMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/module-groups/[id]/modules/new/index.vue?macro=true";
import { default as index7LCwdsy5xaMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/module-groups/index.vue?macro=true";
import { default as newClOks7mOMrMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/module-groups/new.vue?macro=true";
import { default as module_45groupsSR3a0KOJz7Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/module-groups.vue?macro=true";
import { default as _91id_93epFMyaBibNMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/order-statuses/[id].vue?macro=true";
import { default as default_45status_46toggleh4Cq7a3stTMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/order-statuses/filters/default-status.toggle.ts?macro=true";
import { default as indexhzZT0gFR8gMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/order-statuses/index.vue?macro=true";
import { default as newdbOVqMuoRQMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/order-statuses/new.vue?macro=true";
import { default as indexzuVPP4hwXFMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/orders/[id]/index.vue?macro=true";
import { default as _91message_93wsSKDw9konMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/orders/[id]/messages/[message].vue?macro=true";
import { default as index2hPud2Yp3oMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/orders/index.vue?macro=true";
import { default as new8k6F34eDLLMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/orders/new.vue?macro=true";
import { default as indexgTUAhUIAgXMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/orders/pending-shipments/index.vue?macro=true";
import { default as indexvccR9TpswqMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/orders/promised-deliveries/index.vue?macro=true";
import { default as indexRFppM6BPRHMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/orders/shd-mappings/index.vue?macro=true";
import { default as new2MY4XBdXbzMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/orders/shd-mappings/new.vue?macro=true";
import { default as orders4pY9LXkFGEMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/orders.vue?macro=true";
import { default as _91id_932mpDs3J1kiMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/pages/[id].vue?macro=true";
import { default as indexOXstiXTJRpMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/pages/index.vue?macro=true";
import { default as newQdbVGY81myMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/pages/new.vue?macro=true";
import { default as _91id_93yaRGeJjaRLMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/partners/[id].vue?macro=true";
import { default as indexiEKl7W9DFMMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/partners/index.vue?macro=true";
import { default as newnLSeaqZIQoMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/partners/new.vue?macro=true";
import { default as _91id_93QJAlvIRSyfMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/[id].vue?macro=true";
import { default as indexgZp1Yuusv7Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/index.vue?macro=true";
import { default as newiN64QmJy85Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/new.vue?macro=true";
import { default as adyenOHqvhuGvkoMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/adyen.ts?macro=true";
import { default as boricazYwtZbLepCMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/borica.ts?macro=true";
import { default as fibankudOHcSkPzDMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/fibank.ts?macro=true";
import { default as imoje3DACEyp1QvMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/imoje.ts?macro=true";
import { default as indexQdRoPq0PvLMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/index.ts?macro=true";
import { default as intensaSHwUH7az5UMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/intensa.ts?macro=true";
import { default as iyzico0oYOOaOWaLMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/iyzico.ts?macro=true";
import { default as khRdm6uaHNCWMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/kh.ts?macro=true";
import { default as klarnaZs7rQHEi8jMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/klarna.ts?macro=true";
import { default as kustom5xTpOnYEyhMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/kustom.ts?macro=true";
import { default as neopayUbKVgIAQpfMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/neopay.ts?macro=true";
import { default as paymentezzeBuxBESt2Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/paymentez.ts?macro=true";
import { default as paynlDNd1UzimwCMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/paynl.ts?macro=true";
import { default as paypoH6DnLmJe21Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/paypo.ts?macro=true";
import { default as payufHiNQ8L6EbMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/payu.ts?macro=true";
import { default as payuv4n80bmAeLRCMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/payuv4.ts?macro=true";
import { default as powertranzDAUwMrgYGCMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/powertranz.ts?macro=true";
import { default as wirecardS7QbNdmSSAMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/wirecard.ts?macro=true";
import { default as wspayfgfRhKEP14Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/wspay.ts?macro=true";
import { default as webhooksOd8iDJfIMxMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/webhooks.vue?macro=true";
import { default as printerooCmtBcUbbMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/printer.vue?macro=true";
import { default as _91id_93ulKORXzKCtMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/product-families/[id].vue?macro=true";
import { default as indexLq3gwcls15Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/product-families/index.vue?macro=true";
import { default as newwG8a86dVIcMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/product-families/new.vue?macro=true";
import { default as product_45familiesgKGAcocVyFMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/product-families.vue?macro=true";
import { default as indextJ45K47wFlMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/product-filters/[id]/index.vue?macro=true";
import { default as sortf5OiV1tbuYMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/product-filters/[id]/sort.vue?macro=true";
import { default as stats8pAYkgVuxJMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/product-filters/[id]/stats.vue?macro=true";
import { default as indexI63LSs01o8Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/product-filters/index.vue?macro=true";
import { default as newDbrkVoIXvCMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/product-filters/new.vue?macro=true";
import { default as index6XA7ZgmZG7Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/product-filters/product-filter-results/index.vue?macro=true";
import { default as product_45filtersDFZtqYdyqdMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/product-filters.vue?macro=true";
import { default as indexRUtdzPeURNMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/product-stock-logs/index.vue?macro=true";
import { default as indexLeYZe3ei8hMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/product-stocks/debug/index.vue?macro=true";
import { default as indexajFDOMwNgUMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/product-stocks/index.vue?macro=true";
import { default as product_45stocksjVFIIihFqLMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/product-stocks.vue?macro=true";
import { default as _91id_93cTYUYu9sp9Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/[id].vue?macro=true";
import { default as _91id_93xUwxjHKuCpMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/configurator-groups/[id].vue?macro=true";
import { default as indexj5b70n0q7HMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/configurator-groups/index.vue?macro=true";
import { default as newRvzSlfABulMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/configurator-groups/new.vue?macro=true";
import { default as _91id_93w8aCpQhL36Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/coupons-info-box/[id].vue?macro=true";
import { default as indexO2BWiaQcgGMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/coupons-info-box/index.vue?macro=true";
import { default as newuuQMtEfVIPMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/coupons-info-box/new.vue?macro=true";
import { default as _91id_93f84R4YMnfqMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/coupons/[id].vue?macro=true";
import { default as indexlXCMLZ7npOMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/coupons/index.vue?macro=true";
import { default as checkPrefix_46togglemNWxMXs08yMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/coupons/inputs/checkPrefix.toggle.ts?macro=true";
import { default as discountedApplicable_46togglenrAvPHZVegMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/coupons/inputs/discountedApplicable.toggle.ts?macro=true";
import { default as highestDiscount_46togglePQ6zGLuXVUMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/coupons/inputs/highestDiscount.toggle.ts?macro=true";
import { default as isFreeDelivery_46toggle8SW2r3kZcYMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/coupons/inputs/isFreeDelivery.toggle.ts?macro=true";
import { default as loggedInUserOnly_46toggleOJPLeoOoL6Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/coupons/inputs/loggedInUserOnly.toggle.ts?macro=true";
import { default as showCouponInfo_46togglea51gdSqeVmMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/coupons/inputs/showCouponInfo.toggle.ts?macro=true";
import { default as showOnProductListing_46toggle82YtXap92gMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/coupons/inputs/showOnProductListing.toggle.ts?macro=true";
import { default as newL2bUQylrVDMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/coupons/new.vue?macro=true";
import { default as indexVPtQirFTcNMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/customerGroupPrices/index.vue?macro=true";
import { default as indexJ2SqYK9RrZMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/debug/index.vue?macro=true";
import { default as index8hKvy2aYuvMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/hiddenProducts/index.vue?macro=true";
import { default as index5bl7PpCaTHMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/index.vue?macro=true";
import { default as _91id_930WxTDL84VmMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/info-box/[id].vue?macro=true";
import { default as indexesCmKXJXPhMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/info-box/index.vue?macro=true";
import { default as newvv6VFZwCGDMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/info-box/new.vue?macro=true";
import { default as indexQjx1egyUntMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/lowestPrices/index.vue?macro=true";
import { default as _91id_93MULRw9WB36Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/materialSamples/[id].vue?macro=true";
import { default as indexHhMS8ilIf5Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/materialSamples/index.vue?macro=true";
import { default as new6J9C2PPFd3Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/materialSamples/new.vue?macro=true";
import { default as materialSamplesFqwTJb9DSTMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/materialSamples.vue?macro=true";
import { default as indexgjGwOxBkp9Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/missingProducts/index.vue?macro=true";
import { default as newMfbZnWBscZMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/new.vue?macro=true";
import { default as _91id_93cNeHjnPNjGMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/price-syncs/[id].vue?macro=true";
import { default as indexgMaSg7x6KjMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/price-syncs/index.vue?macro=true";
import { default as newtZEcalziXHMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/price-syncs/new.vue?macro=true";
import { default as _91id_936e8wIKGMz6Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/promotions/[id].vue?macro=true";
import { default as _91id_93wGnvaFIpKTMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/promotions/bars/[id].vue?macro=true";
import { default as indexly1qOzOCBpMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/promotions/bars/index.vue?macro=true";
import { default as new8eNo09XvktMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/promotions/bars/new.vue?macro=true";
import { default as indexMAXsWqHPetMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/promotions/exact-promotions/index.vue?macro=true";
import { default as indexMtOW3e7geRMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/promotions/index.vue?macro=true";
import { default as _91id_93ZLZxRuwVRRMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/promotions/multibuy-promotions/[id].vue?macro=true";
import { default as index4GiOZDcd7SMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/promotions/multibuy-promotions/index.vue?macro=true";
import { default as newr2NveIJ1IWMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/promotions/multibuy-promotions/new.vue?macro=true";
import { default as new7cEg0IozN7Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/promotions/new.vue?macro=true";
import { default as promotionsogiBc9IxJKMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/promotions.vue?macro=true";
import { default as _91id_93hrrqMjSgqQMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/reviews/[id].vue?macro=true";
import { default as index9GTSkipBCsMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/reviews/index.vue?macro=true";
import { default as rating_46inputu2FQa5iTaBMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/reviews/inputs/rating.input.ts?macro=true";
import { default as newq6oAQ9nW0SMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/reviews/new.vue?macro=true";
import { default as selectionLXZcoTH5QdMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products/selection.vue?macro=true";
import { default as productsVgt0tXAvwlMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/products.vue?macro=true";
import { default as indexzFFpxFrVihMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/profile/index.vue?macro=true";
import { default as indexCnFC67Thm4Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/purchase-webhooks/index.vue?macro=true";
import { default as _91id_93FeWmI490N7Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/redirects/[id].vue?macro=true";
import { default as indexx1bwjaaVvEMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/redirects/index.vue?macro=true";
import { default as newom9q5eKSs0Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/redirects/new.vue?macro=true";
import { default as indexbKcubhWbLEMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/reports/index.vue?macro=true";
import { default as indexVfCbNBk1gcMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/reports/new/[id]/index.vue?macro=true";
import { default as indexBypJC04ZbyMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/reports/new/index.vue?macro=true";
import { default as _91id_93CtD8UXYNuqMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/reports/product-metrics/[id].vue?macro=true";
import { default as reportsXwnKhcdnqiMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/reports.vue?macro=true";
import { default as _91id_93Ie5N9SvHlrMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/roles/[id].vue?macro=true";
import { default as indexzi8IOD7I9VMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/roles/index.vue?macro=true";
import { default as newBX5PDwQykaMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/roles/new.vue?macro=true";
import { default as sandboxcSmbziZVfuMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/sandbox.vue?macro=true";
import { default as _91id_93audfc8GZtlMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/showrooms/[id].vue?macro=true";
import { default as indexbshR9vVjtdMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/showrooms/index.vue?macro=true";
import { default as newUNrbT9lK0dMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/showrooms/new.vue?macro=true";
import { default as _91id_93aqVSOFhqUGMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/sitemaps/[id].vue?macro=true";
import { default as index2w21MX90sxMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/sitemaps/index.vue?macro=true";
import { default as newEvD2Ex1rZDMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/sitemaps/new.vue?macro=true";
import { default as _91id_93BHAZJ3nSEJMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/speed4trade/[id].vue?macro=true";
import { default as history5PmuCWLy4ZMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/speed4trade/history.vue?macro=true";
import { default as indexoa7NCNwLuwMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/speed4trade/index.vue?macro=true";
import { default as _91id_93fzOqic1pBMMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/static-site-urls/[id].vue?macro=true";
import { default as indexO9Nwqp3dDrMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/static-site-urls/index.vue?macro=true";
import { default as newQ9psZxh8hbMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/static-site-urls/new.vue?macro=true";
import { default as customerayHCSiBaepMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/statistics/customer.vue?macro=true";
import { default as ordereRU5ly0Dz4Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/statistics/order.vue?macro=true";
import { default as _91id_93VM7nieeL0BMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/stock-pools/[id].vue?macro=true";
import { default as indexpq3O0oIfQSMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/stock-pools/index.vue?macro=true";
import { default as newS62Ml6IyiLMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/stock-pools/new.vue?macro=true";
import { default as stock_45poolsTKvt3gvLBlMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/stock-pools.vue?macro=true";
import { default as status_46selectK5jBeNjzUZMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/stock-source-file-downloads/filters/status.select.ts?macro=true";
import { default as stockPool_46selectRISkzw6Tz2Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/stock-source-file-downloads/filters/stockPool.select.ts?macro=true";
import { default as stockSourceFile_46selectuaayk4i2YfMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/stock-source-file-downloads/filters/stockSourceFile.select.ts?macro=true";
import { default as indexpr4SEzuqhMMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/stock-source-file-downloads/index.vue?macro=true";
import { default as stock_45source_45file_45downloadsWoLeS9AVawMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/stock-source-file-downloads.vue?macro=true";
import { default as _91id_932A8O03ZIyMMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/stock-source-files/[id].vue?macro=true";
import { default as index6pqD5XOqk8Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/stock-source-files/index.vue?macro=true";
import { default as newyuyHHwbCVVMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/stock-source-files/new.vue?macro=true";
import { default as stock_45source_45filesR1fgVliWQEMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/stock-source-files.vue?macro=true";
import { default as _91id_93OLLhOklogzMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/tags/[id].vue?macro=true";
import { default as indexj7fAFUwg2pMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/tags/index.vue?macro=true";
import { default as newABRkE0TlXKMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/tags/new.vue?macro=true";
import { default as _91id_93bLzp36r0CcMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/taxes/[id].vue?macro=true";
import { default as indexrZLzDlKawCMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/taxes/index.vue?macro=true";
import { default as new2GiEf7f1lgMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/taxes/new.vue?macro=true";
import { default as taxesraaSkQeZS9Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/taxes.vue?macro=true";
import { default as _91id_93gUcxe0bvxDMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/teasers/[id].vue?macro=true";
import { default as fallback_46toggleM1i0WgQPI5Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/teasers/fallback.toggle.ts?macro=true";
import { default as indexKcKouqcGCdMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/teasers/index.vue?macro=true";
import { default as isActive_46toggle1Ve3oKZJMqMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/teasers/isActive.toggle.ts?macro=true";
import { default as newrK87JcPv1QMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/teasers/new.vue?macro=true";
import { default as _91id_93luKynTUP09Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/templates/[id].vue?macro=true";
import { default as indexHOQnwJYSniMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/templates/index.vue?macro=true";
import { default as newGpoQ8wOYbeMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/templates/new.vue?macro=true";
import { default as templatesTmHmdSWf0bMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/templates.vue?macro=true";
import { default as bulkdlzjziIEdAMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/translations/bulk.vue?macro=true";
import { default as glossaryuHIPgTakAYMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/translations/glossary.vue?macro=true";
import { default as inboxcs5iov4MfrMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/translations/inbox.vue?macro=true";
import { default as indexGkaY881wDdMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/translations/index.vue?macro=true";
import { default as moduleGroupSelect_46inputktGSzYXuppMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/translations/inputs/moduleGroupSelect.input.ts?macro=true";
import { default as pageSelect_46inputMCGxiNDSeRMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/translations/inputs/pageSelect.input.ts?macro=true";
import { default as productSelect_46inputMlGbzbeI07Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/translations/inputs/productSelect.input.ts?macro=true";
import { default as translationModelSelect_46inputzIULvK0gHIMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/translations/inputs/translationModelSelect.input.ts?macro=true";
import { default as _91id_93wqgPRdZlpZMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/translations/jobs/[id].vue?macro=true";
import { default as indexCCFh7SiNb0Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/translations/jobs/index.vue?macro=true";
import { default as playground0mX4zhWivsMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/translations/playground.vue?macro=true";
import { default as _91id_93Tl6HC2PYJ0Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/translations/review/[id].vue?macro=true";
import { default as settingsmF4B4z8wl2Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/translations/settings.vue?macro=true";
import { default as _91id_93ayNjSZSyPCMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/trendshows/[id].vue?macro=true";
import { default as indexh36FNMzoA4Meta } from "/home/nodejs/wonder-backoffice-v2/source/pages/trendshows/index.vue?macro=true";
import { default as new5W787tOJUaMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/trendshows/new.vue?macro=true";
import { default as indexCuYhqwSUSmMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/user-events/index.vue?macro=true";
import { default as user_45eventshjMPspO25NMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/user-events.vue?macro=true";
import { default as _91id_932F80do7d8fMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/users/[id].vue?macro=true";
import { default as indexNcko2nXIIiMeta } from "/home/nodejs/wonder-backoffice-v2/source/pages/users/index.vue?macro=true";
export default [
  {
    name: "403",
    path: "/403",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/403.vue").then(m => m.default || m)
  },
  {
    name: "assistant-ai-product-data-generation",
    path: "/assistant/ai-product-data-generation",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/assistant/ai-product-data-generation.vue").then(m => m.default || m)
  },
  {
    name: "assistant-ai-product-data-purge",
    path: "/assistant/ai-product-data-purge",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/assistant/ai-product-data-purge.vue").then(m => m.default || m)
  },
  {
    name: ai_45product_45data_45reviewdmnQBGey07Meta?.name,
    path: "/assistant/ai-product-data-review",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/assistant/ai-product-data-review.vue").then(m => m.default || m),
    children: [
  {
    name: "assistant-ai-product-data-review-id",
    path: ":id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/assistant/ai-product-data-review/[id].vue").then(m => m.default || m)
  },
  {
    name: "assistant-ai-product-data-review",
    path: "",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/assistant/ai-product-data-review/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "assistant-ai-product-data-id",
    path: "/assistant/ai-product-data/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/assistant/ai-product-data/[id].vue").then(m => m.default || m)
  },
  {
    name: "assistant-ai-product-data",
    path: "/assistant/ai-product-data",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/assistant/ai-product-data/index.vue").then(m => m.default || m)
  },
  {
    name: "assistant-inputs-assistantAttributesSelect.input",
    path: "/assistant/inputs/assistantAttributesSelect.input",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/assistant/inputs/assistantAttributesSelect.input.ts").then(m => m.default || m)
  },
  {
    name: attribute_45groupscBjtbq1ibnMeta?.name,
    path: "/attribute-groups",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/attribute-groups.vue").then(m => m.default || m),
    children: [
  {
    name: "attribute-groups-id",
    path: ":id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/attribute-groups/[id].vue").then(m => m.default || m)
  },
  {
    name: "attribute-groups",
    path: "",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/attribute-groups/index.vue").then(m => m.default || m)
  },
  {
    name: "attribute-groups-new",
    path: "new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/attribute-groups/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "attributes-id-attribute-values-lang",
    path: "/attributes/:id()/attribute-values/:lang()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/attributes/[id]/attribute-values/[lang].vue").then(m => m.default || m)
  },
  {
    name: "attributes-id",
    path: "/attributes/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/attributes/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "attributes",
    path: "/attributes",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/attributes/index.vue").then(m => m.default || m)
  },
  {
    name: "authors-id",
    path: "/authors/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/authors/[id].vue").then(m => m.default || m)
  },
  {
    name: "authors",
    path: "/authors",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/authors/index.vue").then(m => m.default || m)
  },
  {
    name: "authors-new",
    path: "/authors/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/authors/new.vue").then(m => m.default || m)
  },
  {
    name: "baselinker",
    path: "/baselinker",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/baselinker/index.vue").then(m => m.default || m)
  },
  {
    name: "basketsim",
    path: "/basketsim",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/basketsim.vue").then(m => m.default || m)
  },
  {
    name: bi_45centerYpuZUFVgeyMeta?.name,
    path: "/bi-center",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/bi-center.vue").then(m => m.default || m),
    children: [
  {
    name: "bi-center-filters-adspend-toggle",
    path: "filters/adspend-toggle",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/bi-center/filters/adspend-toggle.ts").then(m => m.default || m)
  },
  {
    name: "bi-center-filters-fast-delivery-toggle",
    path: "filters/fast-delivery-toggle",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/bi-center/filters/fast-delivery-toggle.ts").then(m => m.default || m)
  },
  {
    name: "bi-center-filters-metric-date",
    path: "filters/metric-date",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/bi-center/filters/metric-date.ts").then(m => m.default || m)
  },
  {
    name: "bi-center",
    path: "",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/bi-center/index.vue").then(m => m.default || m)
  },
  {
    name: "bi-center-manufacturer-margins",
    path: "manufacturer-margins",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/bi-center/manufacturer-margins.vue").then(m => m.default || m)
  },
  {
    name: "bi-center-manufacturers",
    path: "manufacturers",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/bi-center/manufacturers.vue").then(m => m.default || m)
  },
  {
    name: "bi-center-margin-checks",
    path: "margin-checks",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/bi-center/margin-checks.vue").then(m => m.default || m)
  },
  {
    name: "bi-center-metrics-values",
    path: "metrics-values",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/bi-center/metrics-values.vue").then(m => m.default || m)
  },
  {
    name: "bi-center-performance-stocks",
    path: "performance-stocks",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/bi-center/performance-stocks.vue").then(m => m.default || m)
  },
  {
    name: "bi-center-poas",
    path: "poas",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/bi-center/poas.vue").then(m => m.default || m)
  },
  {
    name: "bi-center-product-metrics",
    path: "product-metrics",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/bi-center/product-metrics.vue").then(m => m.default || m)
  },
  {
    name: "bi-center-product-poas-productId-channelId",
    path: "product-poas/:productId()-:channelId()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/bi-center/product-poas/[productId]-[channelId].vue").then(m => m.default || m)
  },
  {
    name: "bi-center-product-poas",
    path: "product-poas",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/bi-center/product-poas/index.vue").then(m => m.default || m)
  },
  {
    name: "bi-center-stats",
    path: "stats",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/bi-center/stats.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "cache",
    path: "/cache",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/cache/index.vue").then(m => m.default || m)
  },
  {
    name: "campaigns-id",
    path: "/campaigns/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/campaigns/[id].vue").then(m => m.default || m)
  },
  {
    name: "campaigns",
    path: "/campaigns",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/campaigns/index.vue").then(m => m.default || m)
  },
  {
    name: "campaigns-new",
    path: "/campaigns/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/campaigns/new.vue").then(m => m.default || m)
  },
  {
    name: carriersi3nBdw5WWvMeta?.name,
    path: "/carriers",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/carriers.vue").then(m => m.default || m),
    children: [
  {
    name: "carriers-id",
    path: ":id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/carriers/[id].vue").then(m => m.default || m)
  },
  {
    name: "carriers",
    path: "",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/carriers/index.vue").then(m => m.default || m)
  },
  {
    name: "carriers-new",
    path: "new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/carriers/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: categoriesnS8EbYffbVMeta?.name,
    path: "/categories",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/categories.vue").then(m => m.default || m),
    children: [
  {
    name: "categories-id",
    path: ":id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/categories/[id].vue").then(m => m.default || m)
  },
  {
    name: "categories-clone-tree",
    path: "clone-tree",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/categories/clone-tree.vue").then(m => m.default || m)
  },
  {
    name: "categories-filters-active.select",
    path: "filters/active.select",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/categories/filters/active.select.ts").then(m => m.default || m)
  },
  {
    name: "categories-filters-emptyDescription.toggle",
    path: "filters/emptyDescription.toggle",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/categories/filters/emptyDescription.toggle.ts").then(m => m.default || m)
  },
  {
    name: "categories-filters-emptyHeaderImage.select",
    path: "filters/emptyHeaderImage.select",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/categories/filters/emptyHeaderImage.select.ts").then(m => m.default || m)
  },
  {
    name: "categories-filters-emptyName.select",
    path: "filters/emptyName.select",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/categories/filters/emptyName.select.ts").then(m => m.default || m)
  },
  {
    name: "categories-filters-emptyProductFilters.select",
    path: "filters/emptyProductFilters.select",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/categories/filters/emptyProductFilters.select.ts").then(m => m.default || m)
  },
  {
    name: "categories-filters-emptySateliteDesc.select",
    path: "filters/emptySateliteDesc.select",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/categories/filters/emptySateliteDesc.select.ts").then(m => m.default || m)
  },
  {
    name: "categories-filters-emptySeoDesc.toggle",
    path: "filters/emptySeoDesc.toggle",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/categories/filters/emptySeoDesc.toggle.ts").then(m => m.default || m)
  },
  {
    name: "categories-filters-emptySeoTitle.toggle",
    path: "filters/emptySeoTitle.toggle",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/categories/filters/emptySeoTitle.toggle.ts").then(m => m.default || m)
  },
  {
    name: "categories-filters-excludeFromAutoComplete.select",
    path: "filters/excludeFromAutoComplete.select",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/categories/filters/excludeFromAutoComplete.select.ts").then(m => m.default || m)
  },
  {
    name: "categories-filters-query.select",
    path: "filters/query.select",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/categories/filters/query.select.ts").then(m => m.default || m)
  },
  {
    name: "categories-filters-sort.select",
    path: "filters/sort.select",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/categories/filters/sort.select.ts").then(m => m.default || m)
  },
  {
    name: "categories-filters-status.select",
    path: "filters/status.select",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/categories/filters/status.select.ts").then(m => m.default || m)
  },
  {
    name: "categories-filters-virtual.select",
    path: "filters/virtual.select",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/categories/filters/virtual.select.ts").then(m => m.default || m)
  },
  {
    name: "categories-filters-visibility.select",
    path: "filters/visibility.select",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/categories/filters/visibility.select.ts").then(m => m.default || m)
  },
  {
    name: "categories",
    path: "",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/categories/index.vue").then(m => m.default || m)
  },
  {
    name: "categories-inputs-categoryAttributes.input",
    path: "inputs/categoryAttributes.input",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/categories/inputs/categoryAttributes.input.ts").then(m => m.default || m)
  },
  {
    name: "categories-inputs-categoryTree.input",
    path: "inputs/categoryTree.input",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/categories/inputs/categoryTree.input.ts").then(m => m.default || m)
  },
  {
    name: "categories-mappings",
    path: "mappings",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/categories/mappings.vue").then(m => m.default || m)
  },
  {
    name: "categories-new",
    path: "new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/categories/new.vue").then(m => m.default || m)
  },
  {
    name: "categories-product-sorting-id",
    path: "product-sorting/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/categories/product-sorting/[id].vue").then(m => m.default || m)
  },
  {
    name: "categories-tree",
    path: "tree",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/categories/tree.vue").then(m => m.default || m)
  },
  {
    name: "categories-virtual-categories",
    path: "virtual-categories",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/categories/virtual-categories/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: channelsrfYjpYtyfuMeta?.name,
    path: "/channels",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/channels.vue").then(m => m.default || m),
    children: [
  {
    name: "channels-id",
    path: ":id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/channels/[id].vue").then(m => m.default || m)
  },
  {
    name: "channels-filters-available.select",
    path: "filters/available.select",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/channels/filters/available.select.ts").then(m => m.default || m)
  },
  {
    name: "channels-filters-hasMapping.select",
    path: "filters/hasMapping.select",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/channels/filters/hasMapping.select.ts").then(m => m.default || m)
  },
  {
    name: "channels",
    path: "",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/channels/index.vue").then(m => m.default || m)
  },
  {
    name: "channels-inputs-fisEnabled.toggle",
    path: "inputs/fisEnabled.toggle",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/channels/inputs/fisEnabled.toggle.ts").then(m => m.default || m)
  },
  {
    name: "channels-inputs-overwrite.toggle",
    path: "inputs/overwrite.toggle",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/channels/inputs/overwrite.toggle.ts").then(m => m.default || m)
  },
  {
    name: "channels-inputs-productsStatus.input",
    path: "inputs/productsStatus.input",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/channels/inputs/productsStatus.input.ts").then(m => m.default || m)
  },
  {
    name: "channels-inputs-sitemaps.inputs",
    path: "inputs/sitemaps.inputs",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/channels/inputs/sitemaps.inputs.ts").then(m => m.default || m)
  },
  {
    name: "channels-inputs-type.input",
    path: "inputs/type.input",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/channels/inputs/type.input.ts").then(m => m.default || m)
  },
  {
    name: "channels-migration",
    path: "migration",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/channels/migration.vue").then(m => m.default || m)
  },
  {
    name: "channels-new",
    path: "new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/channels/new.vue").then(m => m.default || m)
  },
  {
    name: "channels-remote-categories",
    path: "remote-categories",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/channels/remote-categories.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "collections-id",
    path: "/collections/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/collections/[id].vue").then(m => m.default || m)
  },
  {
    name: "collections",
    path: "/collections",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/collections/index.vue").then(m => m.default || m)
  },
  {
    name: "collections-new",
    path: "/collections/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/collections/new.vue").then(m => m.default || m)
  },
  {
    name: "countries-id",
    path: "/countries/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/countries/[id].vue").then(m => m.default || m)
  },
  {
    name: "countries",
    path: "/countries",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/countries/index.vue").then(m => m.default || m)
  },
  {
    name: "countries-new",
    path: "/countries/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/countries/new.vue").then(m => m.default || m)
  },
  {
    name: currenciesFMRcSs2qiHMeta?.name,
    path: "/currencies",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/currencies.vue").then(m => m.default || m),
    children: [
  {
    name: "currencies-id",
    path: ":id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/currencies/[id].vue").then(m => m.default || m)
  },
  {
    name: "currencies",
    path: "",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/currencies/index.vue").then(m => m.default || m)
  },
  {
    name: "currencies-new",
    path: "new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/currencies/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: customer_45groupsyRT5mOunDLMeta?.name,
    path: "/customer-groups",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/customer-groups.vue").then(m => m.default || m),
    children: [
  {
    name: "customer-groups-id",
    path: ":id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/customer-groups/[id].vue").then(m => m.default || m)
  },
  {
    name: "customer-groups",
    path: "",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/customer-groups/index.vue").then(m => m.default || m)
  },
  {
    name: "customer-groups-new",
    path: "new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/customer-groups/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "customers-customer-mail",
    path: "/customers/:customer()/mail",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/customers/[customer]/mail.vue").then(m => m.default || m)
  },
  {
    name: "customers-customer-messages-message",
    path: "/customers/:customer()/messages/:message()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/customers/[customer]/messages/[message].vue").then(m => m.default || m)
  },
  {
    name: "customers-id",
    path: "/customers/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/customers/[id].vue").then(m => m.default || m)
  },
  {
    name: "customers",
    path: "/customers",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/customers/index.vue").then(m => m.default || m)
  },
  {
    name: "customers-inputs-isMarketingAccepted.toggle",
    path: "/customers/inputs/isMarketingAccepted.toggle",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/customers/inputs/isMarketingAccepted.toggle.ts").then(m => m.default || m)
  },
  {
    name: "customers-inputs-isMarketingSubscribed.toggle",
    path: "/customers/inputs/isMarketingSubscribed.toggle",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/customers/inputs/isMarketingSubscribed.toggle.ts").then(m => m.default || m)
  },
  {
    name: "customers-inputs-isTermsAccepted.toggle",
    path: "/customers/inputs/isTermsAccepted.toggle",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/customers/inputs/isTermsAccepted.toggle.ts").then(m => m.default || m)
  },
  {
    name: "customers-new",
    path: "/customers/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/customers/new.vue").then(m => m.default || m)
  },
  {
    name: "delivery-methods-id",
    path: "/delivery-methods/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/delivery-methods/[id].vue").then(m => m.default || m)
  },
  {
    name: "delivery-methods",
    path: "/delivery-methods",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/delivery-methods/index.vue").then(m => m.default || m)
  },
  {
    name: "delivery-methods-new",
    path: "/delivery-methods/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/delivery-methods/new.vue").then(m => m.default || m)
  },
  {
    name: "delivery-methods-services-id",
    path: "/delivery-methods/services/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/delivery-methods/services/[id].vue").then(m => m.default || m)
  },
  {
    name: "delivery-methods-services",
    path: "/delivery-methods/services",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/delivery-methods/services/index.vue").then(m => m.default || m)
  },
  {
    name: "delivery-methods-services-new",
    path: "/delivery-methods/services/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/delivery-methods/services/new.vue").then(m => m.default || m)
  },
  {
    name: exportsbeaElidDiPMeta?.name,
    path: "/exports",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/exports.vue").then(m => m.default || m),
    children: [
  {
    name: "exports-id",
    path: ":id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/exports/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "exports-id-stats",
    path: ":id()/stats",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/exports/[id]/stats.vue").then(m => m.default || m)
  },
  {
    name: "exports-debug",
    path: "debug",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/exports/debug/index.vue").then(m => m.default || m)
  },
  {
    name: "exports",
    path: "",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/exports/index.vue").then(m => m.default || m)
  },
  {
    name: "exports-model",
    path: "model",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/exports/model.ts").then(m => m.default || m)
  },
  {
    name: "exports-new-id",
    path: "new/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/exports/new/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "exports-new",
    path: "new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/exports/new/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: flagsjEvszKmT2SMeta?.name,
    path: "/flags",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/flags.vue").then(m => m.default || m),
    children: [
  {
    name: "flags-id",
    path: ":id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/flags/[id].vue").then(m => m.default || m)
  },
  {
    name: "flags",
    path: "",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/flags/index.vue").then(m => m.default || m)
  },
  {
    name: "flags-inputs-isHidden.input",
    path: "inputs/isHidden.input",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/flags/inputs/isHidden.input.ts").then(m => m.default || m)
  },
  {
    name: "flags-new",
    path: "new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/flags/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: image_45studio4ZFRIyP2e8Meta?.name,
    path: "/image-studio",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/image-studio.vue").then(m => m.default || m),
    children: [
  {
    name: "image-studio",
    path: "",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/image-studio/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "imports-id",
    path: "/imports/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/imports/[id].vue").then(m => m.default || m)
  },
  {
    name: "imports-filters-import-type.select",
    path: "/imports/filters/import-type.select",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/imports/filters/import-type.select.ts").then(m => m.default || m)
  },
  {
    name: "imports-filters-parent-import.select",
    path: "/imports/filters/parent-import.select",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/imports/filters/parent-import.select.ts").then(m => m.default || m)
  },
  {
    name: "imports-filters-status.select",
    path: "/imports/filters/status.select",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/imports/filters/status.select.ts").then(m => m.default || m)
  },
  {
    name: "imports-import-rows-id",
    path: "/imports/import-rows/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/imports/import-rows/[id].vue").then(m => m.default || m)
  },
  {
    name: "imports-import-rows-filters-status.select",
    path: "/imports/import-rows/filters/status.select",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/imports/import-rows/filters/status.select.ts").then(m => m.default || m)
  },
  {
    name: "imports",
    path: "/imports",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/imports/index.vue").then(m => m.default || m)
  },
  {
    name: "imports-new-old",
    path: "/imports/new-old",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/imports/new-old.vue").then(m => m.default || m)
  },
  {
    name: "imports-new-id",
    path: "/imports/new/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/imports/new/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "imports-new",
    path: "/imports/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/imports/new/index.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "inspiration-images-id",
    path: "/inspiration-images/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/inspiration-images/[id].vue").then(m => m.default || m)
  },
  {
    name: "inspiration-images",
    path: "/inspiration-images",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/inspiration-images/index.vue").then(m => m.default || m)
  },
  {
    name: "inspiration-images-new",
    path: "/inspiration-images/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/inspiration-images/new.vue").then(m => m.default || m)
  },
  {
    name: inspirationsMWA8BWjqhRMeta?.name,
    path: "/inspirations",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/inspirations.vue").then(m => m.default || m),
    children: [
  {
    name: "inspirations-id",
    path: ":id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/inspirations/[id].vue").then(m => m.default || m)
  },
  {
    name: "inspirations",
    path: "",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/inspirations/index.vue").then(m => m.default || m)
  },
  {
    name: "inspirations-new",
    path: "new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/inspirations/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "integrations-hq-stock",
    path: "/integrations/hq-stock",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/integrations/hq-stock/index.vue").then(m => m.default || m)
  },
  {
    name: "integrations",
    path: "/integrations",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/integrations/index.vue").then(m => m.default || m)
  },
  {
    name: "integrations-kare-tracking",
    path: "/integrations/kare-tracking",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/integrations/kare-tracking/index.vue").then(m => m.default || m)
  },
  {
    name: "internal-product-index",
    path: "/internal/product-index",
    meta: indexnYpG1cP1evMeta || {},
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/internal/product-index/index.vue").then(m => m.default || m)
  },
  {
    name: "jobs-filters-status.select",
    path: "/jobs/filters/status.select",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/jobs/filters/status.select.ts").then(m => m.default || m)
  },
  {
    name: "jobs-filters-types.select",
    path: "/jobs/filters/types.select",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/jobs/filters/types.select.ts").then(m => m.default || m)
  },
  {
    name: "jobs",
    path: "/jobs",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/jobs/index.vue").then(m => m.default || m)
  },
  {
    name: "knowledge-base",
    path: "/knowledge-base",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/knowledge-base.vue").then(m => m.default || m)
  },
  {
    name: "languages-id",
    path: "/languages/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/languages/[id].vue").then(m => m.default || m)
  },
  {
    name: "languages",
    path: "/languages",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/languages/index.vue").then(m => m.default || m)
  },
  {
    name: "languages-new",
    path: "/languages/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/languages/new.vue").then(m => m.default || m)
  },
  {
    name: "links-id",
    path: "/links/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/links/[id].vue").then(m => m.default || m)
  },
  {
    name: "links",
    path: "/links",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/links/index.vue").then(m => m.default || m)
  },
  {
    name: "links-new",
    path: "/links/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/links/new.vue").then(m => m.default || m)
  },
  {
    name: "listing-dividers-id",
    path: "/listing-dividers/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/listing-dividers/[id].vue").then(m => m.default || m)
  },
  {
    name: "listing-dividers",
    path: "/listing-dividers",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/listing-dividers/index.vue").then(m => m.default || m)
  },
  {
    name: "listing-dividers-new",
    path: "/listing-dividers/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/listing-dividers/new.vue").then(m => m.default || m)
  },
  {
    name: "login",
    path: "/login",
    meta: loginkrvcOSgXW8Meta || {},
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/login.vue").then(m => m.default || m)
  },
  {
    name: "logout",
    path: "/logout",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/logout.vue").then(m => m.default || m)
  },
  {
    name: "mailchimp-list-configs-id",
    path: "/mailchimp-list-configs/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/mailchimp-list-configs/[id].vue").then(m => m.default || m)
  },
  {
    name: "mailchimp-list-configs",
    path: "/mailchimp-list-configs",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/mailchimp-list-configs/index.vue").then(m => m.default || m)
  },
  {
    name: "mailchimp-list-configs-new",
    path: "/mailchimp-list-configs/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/mailchimp-list-configs/new.vue").then(m => m.default || m)
  },
  {
    name: manufacturer_45deliveriesF2cyX3mvoQMeta?.name,
    path: "/manufacturer-deliveries",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/manufacturer-deliveries.vue").then(m => m.default || m),
    children: [
  {
    name: "manufacturer-deliveries-id",
    path: ":id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/manufacturer-deliveries/[id].vue").then(m => m.default || m)
  },
  {
    name: "manufacturer-deliveries-bulk-create",
    path: "bulk-create",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/manufacturer-deliveries/bulk-create/index.vue").then(m => m.default || m)
  },
  {
    name: "manufacturer-deliveries-bulk-create-inputs-dayOfWeekSelect.input",
    path: "bulk-create/inputs/dayOfWeekSelect.input",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/manufacturer-deliveries/bulk-create/inputs/dayOfWeekSelect.input.ts").then(m => m.default || m)
  },
  {
    name: "manufacturer-deliveries-bulk-create-inputs-periodSelect.input",
    path: "bulk-create/inputs/periodSelect.input",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/manufacturer-deliveries/bulk-create/inputs/periodSelect.input.ts").then(m => m.default || m)
  },
  {
    name: "manufacturer-deliveries-bulk-delete",
    path: "bulk-delete",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/manufacturer-deliveries/bulk-delete/index.vue").then(m => m.default || m)
  },
  {
    name: "manufacturer-deliveries",
    path: "",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/manufacturer-deliveries/index.vue").then(m => m.default || m)
  },
  {
    name: "manufacturer-deliveries-new",
    path: "new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/manufacturer-deliveries/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: manufacturersxSXk8U4sugMeta?.name,
    path: "/manufacturers",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/manufacturers.vue").then(m => m.default || m),
    children: [
  {
    name: "manufacturers-id",
    path: ":id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/manufacturers/[id].vue").then(m => m.default || m)
  },
  {
    name: "manufacturers",
    path: "",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/manufacturers/index.vue").then(m => m.default || m)
  },
  {
    name: "manufacturers-new",
    path: "new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/manufacturers/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "meble",
    path: "/meble",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/meble/index.vue").then(m => m.default || m)
  },
  {
    name: "menu-id",
    path: "/menu/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/menu/[id].vue").then(m => m.default || m)
  },
  {
    name: "menu",
    path: "/menu",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/menu/index.vue").then(m => m.default || m)
  },
  {
    name: "menu-inputs-layout.input",
    path: "/menu/inputs/layout.input",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/menu/inputs/layout.input.ts").then(m => m.default || m)
  },
  {
    name: "menu-inputs-type.input",
    path: "/menu/inputs/type.input",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/menu/inputs/type.input.ts").then(m => m.default || m)
  },
  {
    name: "menu-new",
    path: "/menu/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/menu/new.vue").then(m => m.default || m)
  },
  {
    name: "menu-utils",
    path: "/menu/utils",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/menu/utils.ts").then(m => m.default || m)
  },
  {
    name: module_45groupsSR3a0KOJz7Meta?.name,
    path: "/module-groups",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/module-groups.vue").then(m => m.default || m),
    children: [
  {
    name: "module-groups-id",
    path: ":id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/module-groups/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "module-groups-id-modules-_type",
    path: ":id()/modules/_:type()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/module-groups/[id]/modules/_[type].vue").then(m => m.default || m)
  },
  {
    name: "module-groups-id-modules-moduleId",
    path: ":id()/modules/:moduleId()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/module-groups/[id]/modules/[moduleId].vue").then(m => m.default || m)
  },
  {
    name: "module-groups-id-modules-edit-moduleId-type",
    path: ":id()/modules/edit/:moduleId()/:type()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/module-groups/[id]/modules/edit/[moduleId]/[type].vue").then(m => m.default || m)
  },
  {
    name: "module-groups-id-modules-new-type",
    path: ":id()/modules/new/:type()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/module-groups/[id]/modules/new/[type].vue").then(m => m.default || m)
  },
  {
    name: "module-groups-id-modules-new",
    path: ":id()/modules/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/module-groups/[id]/modules/new/index.vue").then(m => m.default || m)
  },
  {
    name: "module-groups",
    path: "",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/module-groups/index.vue").then(m => m.default || m)
  },
  {
    name: "module-groups-new",
    path: "new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/module-groups/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "order-statuses-id",
    path: "/order-statuses/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/order-statuses/[id].vue").then(m => m.default || m)
  },
  {
    name: "order-statuses-filters-default-status.toggle",
    path: "/order-statuses/filters/default-status.toggle",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/order-statuses/filters/default-status.toggle.ts").then(m => m.default || m)
  },
  {
    name: "order-statuses",
    path: "/order-statuses",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/order-statuses/index.vue").then(m => m.default || m)
  },
  {
    name: "order-statuses-new",
    path: "/order-statuses/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/order-statuses/new.vue").then(m => m.default || m)
  },
  {
    name: orders4pY9LXkFGEMeta?.name,
    path: "/orders",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/orders.vue").then(m => m.default || m),
    children: [
  {
    name: "orders-id",
    path: ":id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/orders/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "orders-id-messages-message",
    path: ":id()/messages/:message()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/orders/[id]/messages/[message].vue").then(m => m.default || m)
  },
  {
    name: "orders",
    path: "",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/orders/index.vue").then(m => m.default || m)
  },
  {
    name: "orders-new",
    path: "new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/orders/new.vue").then(m => m.default || m)
  },
  {
    name: "orders-pending-shipments",
    path: "pending-shipments",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/orders/pending-shipments/index.vue").then(m => m.default || m)
  },
  {
    name: "orders-promised-deliveries",
    path: "promised-deliveries",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/orders/promised-deliveries/index.vue").then(m => m.default || m)
  },
  {
    name: "orders-shd-mappings",
    path: "shd-mappings",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/orders/shd-mappings/index.vue").then(m => m.default || m)
  },
  {
    name: "orders-shd-mappings-new",
    path: "shd-mappings/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/orders/shd-mappings/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "pages-id",
    path: "/pages/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/pages/[id].vue").then(m => m.default || m)
  },
  {
    name: "pages",
    path: "/pages",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "pages-new",
    path: "/pages/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/pages/new.vue").then(m => m.default || m)
  },
  {
    name: "partners-id",
    path: "/partners/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/partners/[id].vue").then(m => m.default || m)
  },
  {
    name: "partners",
    path: "/partners",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/partners/index.vue").then(m => m.default || m)
  },
  {
    name: "partners-new",
    path: "/partners/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/partners/new.vue").then(m => m.default || m)
  },
  {
    name: "payment-methods-id",
    path: "/payment-methods/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/[id].vue").then(m => m.default || m)
  },
  {
    name: "payment-methods",
    path: "/payment-methods",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/index.vue").then(m => m.default || m)
  },
  {
    name: "payment-methods-new",
    path: "/payment-methods/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/new.vue").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-adyen",
    path: "/payment-methods/schemas/adyen",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/adyen.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-borica",
    path: "/payment-methods/schemas/borica",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/borica.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-fibank",
    path: "/payment-methods/schemas/fibank",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/fibank.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-imoje",
    path: "/payment-methods/schemas/imoje",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/imoje.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas",
    path: "/payment-methods/schemas",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/index.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-intensa",
    path: "/payment-methods/schemas/intensa",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/intensa.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-iyzico",
    path: "/payment-methods/schemas/iyzico",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/iyzico.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-kh",
    path: "/payment-methods/schemas/kh",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/kh.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-klarna",
    path: "/payment-methods/schemas/klarna",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/klarna.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-kustom",
    path: "/payment-methods/schemas/kustom",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/kustom.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-neopay",
    path: "/payment-methods/schemas/neopay",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/neopay.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-paymentez",
    path: "/payment-methods/schemas/paymentez",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/paymentez.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-paynl",
    path: "/payment-methods/schemas/paynl",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/paynl.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-paypo",
    path: "/payment-methods/schemas/paypo",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/paypo.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-payu",
    path: "/payment-methods/schemas/payu",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/payu.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-payuv4",
    path: "/payment-methods/schemas/payuv4",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/payuv4.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-powertranz",
    path: "/payment-methods/schemas/powertranz",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/powertranz.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-wirecard",
    path: "/payment-methods/schemas/wirecard",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/wirecard.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-wspay",
    path: "/payment-methods/schemas/wspay",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/schemas/wspay.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-webhooks",
    path: "/payment-methods/webhooks",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/payment-methods/webhooks.vue").then(m => m.default || m)
  },
  {
    name: "printer",
    path: "/printer",
    meta: printerooCmtBcUbbMeta || {},
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/printer.vue").then(m => m.default || m)
  },
  {
    name: product_45familiesgKGAcocVyFMeta?.name,
    path: "/product-families",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/product-families.vue").then(m => m.default || m),
    children: [
  {
    name: "product-families-id",
    path: ":id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/product-families/[id].vue").then(m => m.default || m)
  },
  {
    name: "product-families",
    path: "",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/product-families/index.vue").then(m => m.default || m)
  },
  {
    name: "product-families-new",
    path: "new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/product-families/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: product_45filtersDFZtqYdyqdMeta?.name,
    path: "/product-filters",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/product-filters.vue").then(m => m.default || m),
    children: [
  {
    name: "product-filters-id",
    path: ":id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/product-filters/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "product-filters-id-sort",
    path: ":id()/sort",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/product-filters/[id]/sort.vue").then(m => m.default || m)
  },
  {
    name: "product-filters-id-stats",
    path: ":id()/stats",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/product-filters/[id]/stats.vue").then(m => m.default || m)
  },
  {
    name: "product-filters",
    path: "",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/product-filters/index.vue").then(m => m.default || m)
  },
  {
    name: "product-filters-new",
    path: "new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/product-filters/new.vue").then(m => m.default || m)
  },
  {
    name: "product-filters-product-filter-results",
    path: "product-filter-results",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/product-filters/product-filter-results/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "product-stock-logs",
    path: "/product-stock-logs",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/product-stock-logs/index.vue").then(m => m.default || m)
  },
  {
    name: product_45stocksjVFIIihFqLMeta?.name,
    path: "/product-stocks",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/product-stocks.vue").then(m => m.default || m),
    children: [
  {
    name: "product-stocks-debug",
    path: "debug",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/product-stocks/debug/index.vue").then(m => m.default || m)
  },
  {
    name: "product-stocks",
    path: "",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/product-stocks/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: productsVgt0tXAvwlMeta?.name,
    path: "/products",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products.vue").then(m => m.default || m),
    children: [
  {
    name: "products-id",
    path: ":id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/[id].vue").then(m => m.default || m)
  },
  {
    name: "products-configurator-groups-id",
    path: "configurator-groups/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/configurator-groups/[id].vue").then(m => m.default || m)
  },
  {
    name: "products-configurator-groups",
    path: "configurator-groups",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/configurator-groups/index.vue").then(m => m.default || m)
  },
  {
    name: "products-configurator-groups-new",
    path: "configurator-groups/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/configurator-groups/new.vue").then(m => m.default || m)
  },
  {
    name: "products-coupons-info-box-id",
    path: "coupons-info-box/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/coupons-info-box/[id].vue").then(m => m.default || m)
  },
  {
    name: "products-coupons-info-box",
    path: "coupons-info-box",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/coupons-info-box/index.vue").then(m => m.default || m)
  },
  {
    name: "products-coupons-info-box-new",
    path: "coupons-info-box/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/coupons-info-box/new.vue").then(m => m.default || m)
  },
  {
    name: "products-coupons-id",
    path: "coupons/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/coupons/[id].vue").then(m => m.default || m)
  },
  {
    name: "products-coupons",
    path: "coupons",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/coupons/index.vue").then(m => m.default || m)
  },
  {
    name: "products-coupons-inputs-checkPrefix.toggle",
    path: "coupons/inputs/checkPrefix.toggle",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/coupons/inputs/checkPrefix.toggle.ts").then(m => m.default || m)
  },
  {
    name: "products-coupons-inputs-discountedApplicable.toggle",
    path: "coupons/inputs/discountedApplicable.toggle",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/coupons/inputs/discountedApplicable.toggle.ts").then(m => m.default || m)
  },
  {
    name: "products-coupons-inputs-highestDiscount.toggle",
    path: "coupons/inputs/highestDiscount.toggle",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/coupons/inputs/highestDiscount.toggle.ts").then(m => m.default || m)
  },
  {
    name: "products-coupons-inputs-isFreeDelivery.toggle",
    path: "coupons/inputs/isFreeDelivery.toggle",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/coupons/inputs/isFreeDelivery.toggle.ts").then(m => m.default || m)
  },
  {
    name: "products-coupons-inputs-loggedInUserOnly.toggle",
    path: "coupons/inputs/loggedInUserOnly.toggle",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/coupons/inputs/loggedInUserOnly.toggle.ts").then(m => m.default || m)
  },
  {
    name: "products-coupons-inputs-showCouponInfo.toggle",
    path: "coupons/inputs/showCouponInfo.toggle",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/coupons/inputs/showCouponInfo.toggle.ts").then(m => m.default || m)
  },
  {
    name: "products-coupons-inputs-showOnProductListing.toggle",
    path: "coupons/inputs/showOnProductListing.toggle",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/coupons/inputs/showOnProductListing.toggle.ts").then(m => m.default || m)
  },
  {
    name: "products-coupons-new",
    path: "coupons/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/coupons/new.vue").then(m => m.default || m)
  },
  {
    name: "products-customerGroupPrices",
    path: "customerGroupPrices",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/customerGroupPrices/index.vue").then(m => m.default || m)
  },
  {
    name: "products-debug",
    path: "debug",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/debug/index.vue").then(m => m.default || m)
  },
  {
    name: "products-hiddenProducts",
    path: "hiddenProducts",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/hiddenProducts/index.vue").then(m => m.default || m)
  },
  {
    name: "products",
    path: "",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/index.vue").then(m => m.default || m)
  },
  {
    name: "products-info-box-id",
    path: "info-box/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/info-box/[id].vue").then(m => m.default || m)
  },
  {
    name: "products-info-box",
    path: "info-box",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/info-box/index.vue").then(m => m.default || m)
  },
  {
    name: "products-info-box-new",
    path: "info-box/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/info-box/new.vue").then(m => m.default || m)
  },
  {
    name: "products-lowestPrices",
    path: "lowestPrices",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/lowestPrices/index.vue").then(m => m.default || m)
  },
  {
    name: materialSamplesFqwTJb9DSTMeta?.name,
    path: "materialSamples",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/materialSamples.vue").then(m => m.default || m),
    children: [
  {
    name: "products-materialSamples-id",
    path: ":id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/materialSamples/[id].vue").then(m => m.default || m)
  },
  {
    name: "products-materialSamples",
    path: "",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/materialSamples/index.vue").then(m => m.default || m)
  },
  {
    name: "products-materialSamples-new",
    path: "new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/materialSamples/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "products-missingProducts",
    path: "missingProducts",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/missingProducts/index.vue").then(m => m.default || m)
  },
  {
    name: "products-new",
    path: "new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/new.vue").then(m => m.default || m)
  },
  {
    name: "products-price-syncs-id",
    path: "price-syncs/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/price-syncs/[id].vue").then(m => m.default || m)
  },
  {
    name: "products-price-syncs",
    path: "price-syncs",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/price-syncs/index.vue").then(m => m.default || m)
  },
  {
    name: "products-price-syncs-new",
    path: "price-syncs/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/price-syncs/new.vue").then(m => m.default || m)
  },
  {
    name: promotionsogiBc9IxJKMeta?.name,
    path: "promotions",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/promotions.vue").then(m => m.default || m),
    children: [
  {
    name: "products-promotions-id",
    path: ":id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/promotions/[id].vue").then(m => m.default || m)
  },
  {
    name: "products-promotions-bars-id",
    path: "bars/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/promotions/bars/[id].vue").then(m => m.default || m)
  },
  {
    name: "products-promotions-bars",
    path: "bars",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/promotions/bars/index.vue").then(m => m.default || m)
  },
  {
    name: "products-promotions-bars-new",
    path: "bars/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/promotions/bars/new.vue").then(m => m.default || m)
  },
  {
    name: "products-promotions-exact-promotions",
    path: "exact-promotions",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/promotions/exact-promotions/index.vue").then(m => m.default || m)
  },
  {
    name: "products-promotions",
    path: "",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/promotions/index.vue").then(m => m.default || m)
  },
  {
    name: "products-promotions-multibuy-promotions-id",
    path: "multibuy-promotions/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/promotions/multibuy-promotions/[id].vue").then(m => m.default || m)
  },
  {
    name: "products-promotions-multibuy-promotions",
    path: "multibuy-promotions",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/promotions/multibuy-promotions/index.vue").then(m => m.default || m)
  },
  {
    name: "products-promotions-multibuy-promotions-new",
    path: "multibuy-promotions/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/promotions/multibuy-promotions/new.vue").then(m => m.default || m)
  },
  {
    name: "products-promotions-new",
    path: "new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/promotions/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "products-reviews-id",
    path: "reviews/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/reviews/[id].vue").then(m => m.default || m)
  },
  {
    name: "products-reviews",
    path: "reviews",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: "products-reviews-inputs-rating.input",
    path: "reviews/inputs/rating.input",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/reviews/inputs/rating.input.ts").then(m => m.default || m)
  },
  {
    name: "products-reviews-new",
    path: "reviews/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/reviews/new.vue").then(m => m.default || m)
  },
  {
    name: "products-selection",
    path: "selection",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/products/selection.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: "purchase-webhooks",
    path: "/purchase-webhooks",
    meta: indexCnFC67Thm4Meta || {},
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/purchase-webhooks/index.vue").then(m => m.default || m)
  },
  {
    name: "redirects-id",
    path: "/redirects/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/redirects/[id].vue").then(m => m.default || m)
  },
  {
    name: "redirects",
    path: "/redirects",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/redirects/index.vue").then(m => m.default || m)
  },
  {
    name: "redirects-new",
    path: "/redirects/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/redirects/new.vue").then(m => m.default || m)
  },
  {
    name: reportsXwnKhcdnqiMeta?.name,
    path: "/reports",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/reports.vue").then(m => m.default || m),
    children: [
  {
    name: "reports",
    path: "",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/reports/index.vue").then(m => m.default || m)
  },
  {
    name: "reports-new-id",
    path: "new/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/reports/new/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "reports-new",
    path: "new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/reports/new/index.vue").then(m => m.default || m)
  },
  {
    name: "reports-product-metrics-id",
    path: "product-metrics/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/reports/product-metrics/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "roles-id",
    path: "/roles/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/roles/[id].vue").then(m => m.default || m)
  },
  {
    name: "roles",
    path: "/roles",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/roles/index.vue").then(m => m.default || m)
  },
  {
    name: "roles-new",
    path: "/roles/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/roles/new.vue").then(m => m.default || m)
  },
  {
    name: "sandbox",
    path: "/sandbox",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/sandbox.vue").then(m => m.default || m)
  },
  {
    name: "showrooms-id",
    path: "/showrooms/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/showrooms/[id].vue").then(m => m.default || m)
  },
  {
    name: "showrooms",
    path: "/showrooms",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/showrooms/index.vue").then(m => m.default || m)
  },
  {
    name: "showrooms-new",
    path: "/showrooms/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/showrooms/new.vue").then(m => m.default || m)
  },
  {
    name: "sitemaps-id",
    path: "/sitemaps/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/sitemaps/[id].vue").then(m => m.default || m)
  },
  {
    name: "sitemaps",
    path: "/sitemaps",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/sitemaps/index.vue").then(m => m.default || m)
  },
  {
    name: "sitemaps-new",
    path: "/sitemaps/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/sitemaps/new.vue").then(m => m.default || m)
  },
  {
    name: "speed4trade-detail",
    path: "/speed4trade/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/speed4trade/[id].vue").then(m => m.default || m)
  },
  {
    name: "speed4trade-history",
    path: "/speed4trade/history",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/speed4trade/history.vue").then(m => m.default || m)
  },
  {
    name: "speed4trade",
    path: "/speed4trade",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/speed4trade/index.vue").then(m => m.default || m)
  },
  {
    name: "static-site-urls-id",
    path: "/static-site-urls/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/static-site-urls/[id].vue").then(m => m.default || m)
  },
  {
    name: "static-site-urls",
    path: "/static-site-urls",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/static-site-urls/index.vue").then(m => m.default || m)
  },
  {
    name: "static-site-urls-new",
    path: "/static-site-urls/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/static-site-urls/new.vue").then(m => m.default || m)
  },
  {
    name: "statistics-customer",
    path: "/statistics/customer",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/statistics/customer.vue").then(m => m.default || m)
  },
  {
    name: "statistics-order",
    path: "/statistics/order",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/statistics/order.vue").then(m => m.default || m)
  },
  {
    name: stock_45poolsTKvt3gvLBlMeta?.name,
    path: "/stock-pools",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/stock-pools.vue").then(m => m.default || m),
    children: [
  {
    name: "stock-pools-id",
    path: ":id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/stock-pools/[id].vue").then(m => m.default || m)
  },
  {
    name: "stock-pools",
    path: "",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/stock-pools/index.vue").then(m => m.default || m)
  },
  {
    name: "stock-pools-new",
    path: "new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/stock-pools/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: stock_45source_45file_45downloadsWoLeS9AVawMeta?.name,
    path: "/stock-source-file-downloads",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/stock-source-file-downloads.vue").then(m => m.default || m),
    children: [
  {
    name: "stock-source-file-downloads-filters-status.select",
    path: "filters/status.select",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/stock-source-file-downloads/filters/status.select.ts").then(m => m.default || m)
  },
  {
    name: "stock-source-file-downloads-filters-stockPool.select",
    path: "filters/stockPool.select",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/stock-source-file-downloads/filters/stockPool.select.ts").then(m => m.default || m)
  },
  {
    name: "stock-source-file-downloads-filters-stockSourceFile.select",
    path: "filters/stockSourceFile.select",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/stock-source-file-downloads/filters/stockSourceFile.select.ts").then(m => m.default || m)
  },
  {
    name: "stock-source-file-downloads",
    path: "",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/stock-source-file-downloads/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: stock_45source_45filesR1fgVliWQEMeta?.name,
    path: "/stock-source-files",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/stock-source-files.vue").then(m => m.default || m),
    children: [
  {
    name: "stock-source-files-id",
    path: ":id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/stock-source-files/[id].vue").then(m => m.default || m)
  },
  {
    name: "stock-source-files",
    path: "",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/stock-source-files/index.vue").then(m => m.default || m)
  },
  {
    name: "stock-source-files-new",
    path: "new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/stock-source-files/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "tags-id",
    path: "/tags/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/tags/[id].vue").then(m => m.default || m)
  },
  {
    name: "tags",
    path: "/tags",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/tags/index.vue").then(m => m.default || m)
  },
  {
    name: "tags-new",
    path: "/tags/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/tags/new.vue").then(m => m.default || m)
  },
  {
    name: taxesraaSkQeZS9Meta?.name,
    path: "/taxes",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/taxes.vue").then(m => m.default || m),
    children: [
  {
    name: "taxes-id",
    path: ":id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/taxes/[id].vue").then(m => m.default || m)
  },
  {
    name: "taxes",
    path: "",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/taxes/index.vue").then(m => m.default || m)
  },
  {
    name: "taxes-new",
    path: "new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/taxes/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "teasers-id",
    path: "/teasers/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/teasers/[id].vue").then(m => m.default || m)
  },
  {
    name: "teasers-fallback.toggle",
    path: "/teasers/fallback.toggle",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/teasers/fallback.toggle.ts").then(m => m.default || m)
  },
  {
    name: "teasers",
    path: "/teasers",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/teasers/index.vue").then(m => m.default || m)
  },
  {
    name: "teasers-isActive.toggle",
    path: "/teasers/isActive.toggle",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/teasers/isActive.toggle.ts").then(m => m.default || m)
  },
  {
    name: "teasers-new",
    path: "/teasers/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/teasers/new.vue").then(m => m.default || m)
  },
  {
    name: templatesTmHmdSWf0bMeta?.name,
    path: "/templates",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/templates.vue").then(m => m.default || m),
    children: [
  {
    name: "templates-id",
    path: ":id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/templates/[id].vue").then(m => m.default || m)
  },
  {
    name: "templates",
    path: "",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/templates/index.vue").then(m => m.default || m)
  },
  {
    name: "templates-new",
    path: "new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/templates/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "translations-bulk",
    path: "/translations/bulk",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/translations/bulk.vue").then(m => m.default || m)
  },
  {
    name: "translations-glossary",
    path: "/translations/glossary",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/translations/glossary.vue").then(m => m.default || m)
  },
  {
    name: "translations-inbox",
    path: "/translations/inbox",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/translations/inbox.vue").then(m => m.default || m)
  },
  {
    name: "translations",
    path: "/translations",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/translations/index.vue").then(m => m.default || m)
  },
  {
    name: "translations-inputs-moduleGroupSelect.input",
    path: "/translations/inputs/moduleGroupSelect.input",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/translations/inputs/moduleGroupSelect.input.ts").then(m => m.default || m)
  },
  {
    name: "translations-inputs-pageSelect.input",
    path: "/translations/inputs/pageSelect.input",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/translations/inputs/pageSelect.input.ts").then(m => m.default || m)
  },
  {
    name: "translations-inputs-productSelect.input",
    path: "/translations/inputs/productSelect.input",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/translations/inputs/productSelect.input.ts").then(m => m.default || m)
  },
  {
    name: "translations-inputs-translationModelSelect.input",
    path: "/translations/inputs/translationModelSelect.input",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/translations/inputs/translationModelSelect.input.ts").then(m => m.default || m)
  },
  {
    name: "translations-jobs-id",
    path: "/translations/jobs/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/translations/jobs/[id].vue").then(m => m.default || m)
  },
  {
    name: "translations-jobs",
    path: "/translations/jobs",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/translations/jobs/index.vue").then(m => m.default || m)
  },
  {
    name: "translations-playground",
    path: "/translations/playground",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/translations/playground.vue").then(m => m.default || m)
  },
  {
    name: "translations-review-id",
    path: "/translations/review/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/translations/review/[id].vue").then(m => m.default || m)
  },
  {
    name: "translations-settings",
    path: "/translations/settings",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/translations/settings.vue").then(m => m.default || m)
  },
  {
    name: "trendshows-id",
    path: "/trendshows/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/trendshows/[id].vue").then(m => m.default || m)
  },
  {
    name: "trendshows",
    path: "/trendshows",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/trendshows/index.vue").then(m => m.default || m)
  },
  {
    name: "trendshows-new",
    path: "/trendshows/new",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/trendshows/new.vue").then(m => m.default || m)
  },
  {
    name: user_45eventshjMPspO25NMeta?.name,
    path: "/user-events",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/user-events.vue").then(m => m.default || m),
    children: [
  {
    name: "user-events",
    path: "",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/user-events/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "users-id",
    path: "/users/:id()",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/users/[id].vue").then(m => m.default || m)
  },
  {
    name: "users",
    path: "/users",
    component: () => import("/home/nodejs/wonder-backoffice-v2/source/pages/users/index.vue").then(m => m.default || m)
  }
]